import { render, staticRenderFns } from "./FilePathDisplay.vue?vue&type=template&id=3a0ff210&"
import script from "./FilePathDisplay.vue?vue&type=script&lang=ts&"
export * from "./FilePathDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports